import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: column;
  width: 100%;
`;

export const Content = styled.div`
  background-color: white;
  width: fit-content;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem;
  text-decoration: none;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const mainText = {
  fontSize: '1rem',
  fontFamily: 'var(--app-font)',
  fontWeight: 'bold',
  color: 'gray',
  textDecoration: 'none',
};

export const subText = {
  fontSize: '.9rem',
  fontFamily: 'var(--app-font)',
  fontWeight: 'bold',
  color: 'gray',
  textDecoration: 'none',
};

export const altMainText = {
  fontSize: '1.5rem',
  fontFamily: 'var(--app-font)',
  fontWeight: 'bold',
  color: 'black',
};

export const altSubText = {
  fontSize: '1rem',
  fontFamily: 'var(--app-font)',
  fontWeight: 'bold',
  color: 'gray',
};

export default {
  Container,
  Content,
  TextContainer,
  altMainText,
  altSubText,
};
